/**
 * useReferralDashboardData — charge le code de parrainage de la page (patron B).
 *
 * Reprend le choix d'appel du legacy tel quel (`ReferralCodeScreen.js:78-85`) : un hash ⇒
 * `showReferralCodeByHash`, sinon `getReferralCode` sans paramètre. La réponse n'atteignant aucun
 * réducteur, elle vit ici ; la mise en forme est dans `referralDashboardViewModel`.
 *
 * `getReferralCode` est aussi alimenté par la modale de partage (`useReferralShareAdapter`, préchargé
 * par le détail d'un bilan) : la garde `awaiting` de `useApiFetch` garantit qu'on ne consomme que la
 * réponse qu'on a demandée. L'erreur, elle, reste sur la tranche — c'est le view-model qui la lit.
 */
import { referralService } from "../../../../../../data/services/referralService"
import { type ReferralCodePayload } from "../../../types/referralCode"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useReferralDashboardData(hash: string | null | undefined) {
    const { raw, loading, fetch } = useApiFetch<ReferralCodePayload>({
        service: hash ? referralService.showReferralCodeByHash : referralService.getReferralCode,
        routeParams: hash ? { hash } : {},
        requestKey: hash ?? null,
        // Les deux entrées de la page : celle qu'on n'a pas appelée peut porter un reste.
        idleOnUnmount: [referralService.showReferralCodeByHash, referralService.getReferralCode],
    })

    return { raw, loading, retry: fetch }
}
